import React from 'react';
import { Navigate } from 'react-router';
import useAuthStore from '../store/useAuthStore';
import AppLayout from '../layouts/app-layouts';
import { requestData } from './request';

const PrivateRoute = () => {
  const auth = useAuthStore((s) => s.auth);

  const Auth = localStorage.getItem('Pulsalink-Admin-Auth');
  const AuthKey = localStorage.getItem('Pulsalink-Admin-Auth-Key');
  const AuthUser = localStorage.getItem('Pulsalink-Admin-Auth-User');

  const request = (action, data, method) => {
    const formData = { api_token: AuthKey, ...data };

    return requestData(action, formData, method);
  };

  if (auth && Auth != null && AuthKey != null && AuthUser != null) {
    // ✅ Allow all authenticated users to access the app
    // Individual pages will check their own permissions
    return <AppLayout request={(url, body, method) => request(url, body, method)} />;
  } else {
    return <Navigate to={'/user/login'} />;
  }
};

export default PrivateRoute;
